export enum EViewerCursorActionType {
  SET_CROSSHAIR = 'viewer/cursor/SET_CROSSHAIR',
  UNSET_CROSSHAIR = 'viewer/cursor/UNSET_CROSSHAIR',
  SET_WAITING = 'viewer/cursor/SET_WAITING',
  UNSET_WAITING = 'viewer/cursor/UNSET_WAITING',
  SET_WORKING = 'viewer/cursor/SET_WORKING',
  UNSET_WORKING = 'viewer/cursor/UNSET_WORKING',
}
